import styled from 'styled-components'

export const Title = styled.h2`
  color: ${(props) => props.theme.heading};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 1rem;
`
